import { io } from "socket.io-client";
import config from "../config";

// Socket.IO server runs on the BACKEND API, not the frontend
const socketUrl = config.API_URL;

console.log("=== SOCKET CONNECTION DEBUG ===");
console.log("Socket.IO connecting to:", socketUrl);
console.log("===============================");

const socket = io(socketUrl, {
  transports: ["websocket", "polling"], // Try WebSocket first, fallback to polling
  forceNew: true,
  reconnection: true,
  reconnectionAttempts: 10,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  timeout: 20000,
  autoConnect: true,
  withCredentials: true,
  path: "/socket.io/", // Explicit path for Socket.IO
});

// Handle connection events
socket.on("connect", () => {
  console.log("Connected to server:", socket.id);
});

socket.on("disconnect", (reason) => {
  console.warn("Socket disconnected:", reason);
});

socket.on("connect_error", (err) => {
  console.error("Connection error:", err.message);
});

socket.on("reconnect_attempt", (attemptNumber) => {
  console.log(`Reconnection attempt #${attemptNumber}`);
});

export default socket;
